import React, { useRef } from "react";
import useViewerController from "./use-viewer-controller";
import { ViewerProps } from "./viewer-props.interface";
import everseLogo from "../../../../assets/images/everse-logo.png";
import "./_viewer.scss";

const Viewer = ({ loaderConfig, onLoadSuccessCallback, onLoadErrorCallback }: ViewerProps) => {
  const viewerContainerRef = useRef(null);
  const {
    unityPlayerCanvasBuilt,
    unityPlayerCanvasIsBeingUsed,
    unityPlayerLoadProgress,
  } = useViewerController({
    loaderConfig, onLoadSuccessCallback, onLoadErrorCallback
  });

  const playerLoadPercentage = +(unityPlayerLoadProgress * 100).toFixed(2);

  return (
    <div
      ref={viewerContainerRef}
      id="unity-viewer-container"
      className="unity-desktop"
    >
      {unityPlayerCanvasIsBeingUsed && unityPlayerCanvasBuilt}
      {playerLoadPercentage < 100 && (
        <div id="unityplayer-loading-container">
          <img alt="logo" src={everseLogo} className="unityplayer-loading-logo" />
          <progress
            className="unityplayer-progress-bar"
            value={playerLoadPercentage}
            max="100"
          >
            <data>{playerLoadPercentage}</data>%
          </progress>
        </div>
      )}
    </div>
  );
};

export default Viewer;
